<template>
  <div class="head-guide of">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/pages' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="item.router" v-for="(item,idx) in menuData" :key="idx">{{item.label}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button icon="el-icon-back" circle class="guide-icon-back" @click="$router.back()" v-if="backButtonVisible"></el-button>
  </div>
</template>

<script>
  export default {
    name: "NavBreadcrumb",
    data() {
      return {
      }
    },
    props: {
      menu: {
        type: Array,
        default:()=>{
          return []
        }
      },
      backButtonVisible: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      menuData: function () {
        return this.menu
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NavBreadcrumb.vue